module.exports = __webpack_public_path__ + "static/img/R5.0635b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/R5.png
// module id = aL2a
// module chunks = 0